import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../../Utils/thunkHelpers"
import { getStatisticsAdmin } from "../../../BusinessAccountsPage/redux/businessAccounts.thunks"
import * as services from "../services"
import { REQUESTS_INTEGRATIONS_SLICE_NAME } from "./requestsIntegrations.constants"

export const getRequestsIntegrations = createAsyncThunk(
  `${REQUESTS_INTEGRATIONS_SLICE_NAME}/get_requests_integrations`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getIntegrationsRequests(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const deleteRequestsIntegration = createAsyncThunk(
  `${REQUESTS_INTEGRATIONS_SLICE_NAME}/delete_requests_integration`,
  async (id, { dispatch, rejectWithValue }) => {
    const response = await services.deleteIntegrationRequests(id)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    dispatch(getStatisticsAdmin())
    return { id, message: response.data?.message?.detail || response.data?.message }
  }
)

export const getRequestsIntegrationsExport = createAsyncThunk(
  `${REQUESTS_INTEGRATIONS_SLICE_NAME}/get_requests_integrations_export`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getRequestsIntegrationsExport(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
